<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <deadline-list-filter />
      <deadline-list-header />
      <deadline-list-table />
    </div>
  </div>
</template>

<script>

export default {
  name: 'DeadlineList',
  computed: {
  }
}
</script>

<style>

</style>
